import React from 'react';
import { format } from 'date-fns';

type DateColumnProps = {
  value: Date | null;
};

const DateColumn = ({ value }: DateColumnProps): JSX.Element => {
  if (!value) {
    return null;
  }

  return <span>{format(value, 'MMM d, u')}</span>
};

export default DateColumn;
